import PutawayHeader from '@/models/PutawayHeader/PutawayHeader';

export default class PutawayHeaderFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.putawayHeaderNo = '';
		this.scannedById  = '';
		this.scannedByFirstName = '';
		this.putawayCategoryId  = '';
		this.putawayCategoryName = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.processDateFrom = '';
		this.processDateTo = '';
		this.areaId  = '';
		this.areaCode = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			putawayHeaderNo : '0',
			scannedById : '0',
			scannedByFirstName : '0',
			putawayCategoryId : '0',
			putawayCategoryName : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			processDateFrom : '0',
			processDateTo : '0',
			areaId : '0',
			areaCode : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}